// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aa-accordion-dialog-tasks .aa-accordion-item {
  border-radius: 0px 10px 10px 10px;
  border: 1px solid var(--AA-gloabl-border);
  background: var(--AA-global-white-bg);
  transition: 0.2s;
  overflow: hidden;
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-header {
  border: 0;
  background: transparent;
  text-align: start;
  transition: background-color 0.2s ease;
  text-align: start;
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-header .aa-accordion-header-icon {
  transition: transform 0.3s ease;
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-header .aa-accordion-header-icon.open-accordion-icon {
  transform: rotate(180deg);
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-header .aa-accordion-header-icon svg path {
  stroke: var(--AA-gloabl-text-color);
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-header.active-bg-header {
  background-color: var(--AA-gloabl-bg-secondary);
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-content {
  max-height: 0;
  overflow: auto;
  transition: max-height 0.3s ease-out;
  background: var(--AA-global-white-bg);
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-content.is-open-accordion-content {
  max-height: max-content;
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-content.is-open-accordion-content .aa-accordion-content-inner {
  opacity: 1;
}
.aa-accordion-dialog-tasks .aa-accordion-item .aa-accordion-content .aa-accordion-content-inner {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.highlight-text {
  background-color: yellow;
}`, "",{"version":3,"sources":["webpack://./src/components/common/templatemanager/tabs/suggestions/dialog/dialog.scss"],"names":[],"mappings":"AACQ;EACI,iCAAA;EACA,yCAAA;EACA,qCAAA;EACA,gBAAA;EACA,gBAAA;AAAZ;AACY;EACI,SAAA;EACA,uBAAA;EACA,iBAAA;EACA,sCAAA;EACA,iBAAA;AAChB;AAAgB;EACI,+BAAA;AAEpB;AADoB;EACI,yBAAA;AAGxB;AAAwB;EACI,mCAAA;AAE5B;AAEgB;EACI,+CAAA;AAApB;AAGY;EACI,aAAA;EACA,cAAA;EACA,oCAAA;EACA,qCAAA;AADhB;AAEgB;EACI,uBAAA;AAApB;AACoB;EACI,UAAA;AACxB;AAEgB;EACI,UAAA;EACA,6BAAA;AAApB;;AAMA;EACQ,wBAAA;AAHR","sourcesContent":[".aa-accordion-dialog-tasks{\n        .aa-accordion-item{\n            border-radius: 0px 10px 10px 10px;\n            border: 1px solid var(--AA-gloabl-border);\n            background: var(--AA-global-white-bg);\n            transition: 0.2s;\n            overflow: hidden;\n            .aa-accordion-header{\n                border: 0;\n                background: transparent;\n                text-align: start;\n                transition: background-color 0.2s ease;\n                text-align: start;\n                .aa-accordion-header-icon{\n                    transition: transform 0.3s ease;\n                    &.open-accordion-icon {\n                        transform: rotate(180deg);\n                    }\n                    svg{\n                        path{\n                            stroke: var(--AA-gloabl-text-color);\n                        }\n                    }\n                }\n                &.active-bg-header {\n                    background-color: var(--AA-gloabl-bg-secondary);\n                }\n            }\n            .aa-accordion-content{\n                max-height: 0;\n                overflow: auto;\n                transition: max-height 0.3s ease-out;\n                background: var(--AA-global-white-bg);\n                &.is-open-accordion-content {\n                    max-height: max-content;\n                    .aa-accordion-content-inner {\n                        opacity: 1;\n                    }\n                }\n                .aa-accordion-content-inner {\n                    opacity: 0;\n                    transition: opacity 0.2s ease;\n                }\n            }\n        }\n    }\n\n.highlight-text{\n        background-color: yellow;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
